import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { CargueArchivoPagosComponent } from './CargueArchivoPagos.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CargueArchivoPagos',
        component: CargueArchivoPagosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CargueArchivoPagos',
          nombreFormulario : 'Cargue Archivo Pagos'
        } 
    }
];

@NgModule({
    declarations: [
        CargueArchivoPagosComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        CargueArchivoPagosComponent
    ],
    bootstrap: [CargueArchivoPagosComponent]
})

export class CargueArchivoPagosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueArchivoPagos/CargueArchivoPagos.module.ts